import LoginForm from './components/LoginForm/index';
import LoginFooter from './components/LoginFooter/index';
import useUser from '../../hooks/useUser';
import { Stack } from '@chaser/components';
import { Redirect } from 'react-router-dom';
import style from './AuthPage.module.scss';

const Login = () => {
  const { isLoggedIn } = useUser();

  if (isLoggedIn) {
    return (
      <Redirect
        to={{
          pathname: '/',
        }}
      />
    );
  }

  return (
    <Stack className={style.authPage} justifyContent="space-between">
      <div className={style.authTop}>
        <LoginForm />
      </div>
      <div className={style.authFooter}>
        <LoginFooter hideSignupLink />
      </div>
    </Stack>
  );
};

export default Login;
